import { createFileRoute } from "@tanstack/react-router";
import { ProfilePage } from "@/modules/users/presentation/pages/ProfilePage";

export const Route = createFileRoute("/_authenticated/profile")({
  component: ProfilePage,
});
